export const trimJsonFromDFD = (s: string): string => s.slice(1, s.length - 1);
